/**
 * Web-specific Navigator
 * Uses the same structure as native but with web-optimized components
 */
import React from 'react';
import MyTabs from '../src/navigation/BottomTab/bottomTab';

const WebNavigator = () => {
  return <MyTabs />;
};

export default WebNavigator;